import React from 'react';
import { Spinner } from '@lightspeed/flame/Spinner';
import Text from '@lightspeed/cirrus-text';

const StepLoading = ({ text }) => (
  <div className="cr-flex cr-items-center cr-justify-center cr-m-10 cr-p-10">
    <div className="cr-text-center">
      <Spinner size="2rem" color="gray-300" />
      {text && (
        <div className="cr-p-1">
          <Text>{text}</Text>
        </div>
      )}
    </div>
  </div>
);

export default StepLoading;
